import "@css/app.pcss";
import 'vidstack/player';
import 'vidstack/player/ui';

import Alpine from 'alpinejs';
import Collapse from '@alpinejs/collapse';
window.Alpine = Alpine;
Alpine.plugin(Collapse);

import '@js/components/menu';
import '@js/components/menuMobile';
import '@js/components/languageBannerLogic';
import '@js/components/scrollMenu.ts';

import lazysizes from '@js/components/lazysizes';
lazysizes();

Alpine.start();

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
// if (import.meta.hot) {
//   import.meta.hot.accept(() => {
//     console.log("HMR");
//   });
// }
